import { addDays, fromIso, iso } from '../format/dates'
import { toMinutes } from './schedule'
import { salonDayFor, upcomingSalonDays } from './salonDays'
import type { OpeningDay, SalonDayException } from '../types/site'

const WEEKDAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']

export type VisitStatus = { open: boolean; label: string }

/**
 * De regel bij "Kom langs". De salon werkt alleen op afspraak, dus nooit "open", wel wanneer je
 * terecht kunt. Afwijkende dagen (vakantie, ruil) gaan voor de vaste week.
 *
 * - "Vandaag op afspraak, 13:00 – 20:00"
 * - na sluiten of een dichte dag: "Morgen weer op afspraak vanaf 09:00" /
 *   "Weer op afspraak op dinsdag vanaf 13:00"
 * - niets gevonden binnen vier weken: "Op dit moment geen afspraken"
 *
 * Puur.
 */
export function visitStatus(hours: readonly OpeningDay[], exceptions: readonly SalonDayException[] | undefined, now: Date): VisitStatus {
  const today = salonDayFor(hours, exceptions, iso(now))
  const minutes = now.getHours() * 60 + now.getMinutes()
  if (today && minutes < toMinutes(today.close)) return { open: true, label: `Vandaag op afspraak, ${today.open} – ${today.close}` }

  const next = upcomingSalonDays(hours, exceptions, 1, { from: now })[0]
  if (!next) return { open: false, label: 'Op dit moment geen afspraken' }
  if (next.date === iso(addDays(now, 1))) return { open: false, label: `Morgen weer op afspraak vanaf ${next.open}` }
  return { open: false, label: `Weer op afspraak op ${WEEKDAYS[fromIso(next.date).getDay()]} vanaf ${next.open}` }
}
